import * as PIXI from 'pixi.js';

interface LogMessage {
  text: string;
  timestamp: number;
  textObject: PIXI.Text;
}

export class LogMessages {
  private container: PIXI.Container;
  private messages: LogMessage[] = [];
  private maxMessages: number = 5;
  private messageLifetime: number = 5000; // 5 seconds in milliseconds

  constructor() {
    this.container = new PIXI.Container();
    // Position in right sidebar for 1080p
    // Map is centered at x=640, width=640, so right edge is at 1280
    // Log messages in right sidebar, below settings button
    this.container.x = 1320;
    this.container.y = 50; // Below settings button
    this.setupContainer();
  }

  private setupContainer(): void {
    // No background - transparent panel, only text shows
  }

  addMessage(text: string): void {
    const now = Date.now();
    
    // Create text object
    const textObj = new PIXI.Text(text, {
      fontFamily: 'Courier New',
      fontSize: 16,
      fill: 0xffffff,
      wordWrap: true,
      wordWrapWidth: 300,
    });
    
    // Calculate y position (messages stack from top)
    let yPos = 10;
    for (const msg of this.messages) {
      yPos += msg.textObject.height + 5;
    }
    
    textObj.x = 5;
    textObj.y = yPos;
    this.container.addChild(textObj);
    
    // Add to messages array
    this.messages.push({
      text,
      timestamp: now,
      textObject: textObj,
    });
    
    // Limit number of messages
    if (this.messages.length > this.maxMessages) {
      const oldest = this.messages.shift();
      if (oldest) {
        this.container.removeChild(oldest.textObject);
      }
    }
  }

  update(): void {
    const now = Date.now();
    const toRemove: LogMessage[] = [];
    
    // Check for expired messages
    for (const msg of this.messages) {
      if (now - msg.timestamp > this.messageLifetime) {
        toRemove.push(msg);
      }
    }
    
    // Remove expired messages
    for (const msg of toRemove) {
      this.container.removeChild(msg.textObject);
      const index = this.messages.indexOf(msg);
      if (index >= 0) {
        this.messages.splice(index, 1);
      }
    }
    
    // Reposition remaining messages
    let yPos = 10;
    for (const msg of this.messages) {
      msg.textObject.y = yPos;
      yPos += msg.textObject.height + 5;
    }
  }

  getContainer(): PIXI.Container {
    return this.container;
  }
}

